import { render, staticRenderFns } from "./activity-guidance-revision.vue?vue&type=template&id=558e48a3"
import script from "./activity-guidance-revision.vue?vue&type=script&lang=js"
export * from "./activity-guidance-revision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports